import { FC } from 'react';
import { useTranslation } from 'next-i18next';
import styled from 'styled-components';

import { COLORS } from '@/shared/constants/colors';
import { InboxDto } from '@/shared/lib/sj-orm/models/inbox.dto';

type FieldEmailInfoProps = {
  email: InboxDto;
};

export const FieldEmailInfo: FC<FieldEmailInfoProps> = ({ email }) => {
  const { t } = useTranslation('entities/inbox', { keyPrefix: 'emails' });

  return (
    <Container>
      <Subject>{email.emailSubject || t('noSubject')}</Subject>
      <Body>{email.emailBody}</Body>
    </Container>
  );
};

const Container = styled.div`
  max-width: 300px;
  height: 36px;
  display: flex;
  flex-direction: column;
`;

const Subject = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box; /* Required for -webkit-line-clamp */
  -webkit-box-orient: vertical; /* Required for -webkit-line-clamp */
  -webkit-line-clamp: 1;
`;

const Body = styled(Subject)`
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: ${COLORS.systemDark200};
`;
